import React from 'react';

// Generate a build number using the current date in format YYYYMMDD
const getBuildNumber = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}${month}${day}`;
};

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <span className="version">Version: v1.1.0</span>
        <span className="build-date">Build: {getBuildNumber()}</span>
      </div>
    </footer>
  );
};

export default Footer; 